import React, {useState, useEffect, useRef} from "react";
import {ReactComponent as SVGStar} from '../../assets/star.svg';
import {ReactComponent as SVGComment} from '../../assets/comment.svg';
import "./index.scss";
import api from "api";
import _ from "lodash";
import update from 'immutability-helper';
import { usePopper } from 'react-popper';
import { AvatarHorizontal2, AvatarVertical2, AvatarReducer } from "component/Avatar";
import { popinfo } from "component/Fancybox/Fancybox";
import { useFormik } from "formik";
import PaginationWrapper from "component/Pagination";
import { format, parseISO, isValid } from 'date-fns';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import stateMap from "store/stateMap";
import { connect } from 'react-redux';

const StarsList = (props) => {
    return (
        <div className={`component-stars-list ${!props.onClick && 'no-cursor'}`}>
            <button className={`star star-5 ${props.score && props.score >= 5 && 'active'}`} title={props.onClick && 'Give 5 Star to all member'} onClick={(e) => {
                e.preventDefault();
                if(props.onClick) props.onClick.apply(null,[5]);
            }}><SVGStar/></button>
            <button className={`star star-4 ${props.score && props.score >= 4 && 'active'}`} title={props.onClick && 'Give 4 Star to all member'} onClick={(e) => {
                e.preventDefault();
                if(props.onClick) props.onClick.apply(null,[4]);
            }}><SVGStar/></button>
            <button className={`star star-3 ${props.score && props.score >= 3 && 'active'}`} title={props.onClick && 'Give 3 Star to all member'} onClick={(e) => {
                e.preventDefault();
                if(props.onClick) props.onClick.apply(null,[3]);
            }}><SVGStar/></button>
            <button className={`star star-2 ${props.score && props.score >= 2 && 'active'}`} title={props.onClick && 'Give 2 Star to all member'} onClick={(e) => {
                e.preventDefault();
                if(props.onClick) props.onClick.apply(null,[2]);
            }}><SVGStar/></button>
            <button className={`star star-1 ${props.score && props.score >= 1 && 'active'}`} title={props.onClick && 'Give 1 Star to all member'} onClick={(e) => {
                e.preventDefault();
                if(props.onClick) props.onClick.apply(null,[1]);
            }}><SVGStar/></button>
        </div>
    )
}

const RatingMessage = (props) => {
    const [member, setMember]                       = useState(props.member);
    const [referenceElement, setReferenceElement]   = useState(null);
    const [popperElement, setPopperElement]         = useState(null);
    const { styles, attributes }                    = usePopper(referenceElement, popperElement, {});
    const [showForm, setShowForm]                   = useState(props.show);

    const popperWrapper = useRef(null);
    const BodyClick = (e) => {
        if (popperWrapper.current && !popperWrapper.current.contains(e.target)) 
        {
            setShowForm(false);
        }
    }
    const formik = useFormik({
        initialValues : {
            SourceType  : props.sourceType
        }
        ,onSubmit : (values) => {
            let SavingLoader = popinfo('loader', 'Send Message', 'Thank you for taking your time to give a testimonial' );

        api('/UserTestimony', 'post', values, 'Bearer ' + props.token)
                .then((response) => {
                    SavingLoader.close();

                    setShowForm(false);

                    props.onSave.apply(null, [response.member]);

                })
                .catch((error) => {

                    popinfo('error', 'Send Message', error, {}, SavingLoader);
                })
        }
    })
    useEffect(() => {
        document.addEventListener('click', BodyClick, true);
        return () => {
            document.removeEventListener('click', BodyClick, true);
        }
    },[]);

    useEffect(() => {
        
        setShowForm(props.show);

    }, [props.show]);

    useEffect(() => {
        
        setMember(props.member);
        
        formik.setFieldValue('RatingID', props.member.RatingID);
        
        formik.setFieldValue('Testimony', props.member.RatingMessage || '');

    }, [props.member]);

    return (
        <div className="component-rating-message" ref={popperWrapper}>
            <button 
                ref={setReferenceElement} 
                title={`${props.member.RatingMessage ? 'Testimonial Given' : 'Add Testimonial'}`}
                className={`message-trigger ${props.member.RatingMessage && 'has-message'}`} 
                onClick={e=>{
                    e.preventDefault();
                    if(member.RatingID)
                    {
                        setShowForm(true);

                    }
                    else
                    {
                        popinfo('error', 'Ooopss', 'You must rate the person before can give testimony');
                    }
            }}>
                {
                    props.member.RatingMessage && <span className="message-trigger-notif"></span>
                }
                <SVGComment/>
            </button>
            {
                showForm && 
                <div className="rating-message-form" ref={setPopperElement} style={styles.popper}>
                    <form className="generic-form" onSubmit={formik.handleSubmit}>
                        <div>
                            <textarea 
                                rows="2" 
                                className="form-control textarea" 
                                onChange={formik.handleChange}
                                value={formik.values.Testimony}
                                name="Testimony"
                                placeholder="Type your message about this user..."
                            ></textarea>
                        </div>
                        <div className="flex flex-wrap">
                            <a href="#" className="btn btn-primary btn-small btn-reverse" onClick={e=>{
                                e.preventDefault();

                                setShowForm(false);

                            }}>Close</a>&nbsp;
                            <input type="submit" className="btn btn-primary btn-small " value="Add Message" />
                        </div>
                    </form>
                </div>
            }
        </div>
    )
}

const RatingsList = (props) => {
    const [members, setMembers] = useState(false);
    const [total, setTotal]     = useState(false);
    const [paged, setPaged]     = useState(1);

    const internalBatchRating = (updatedMembers, rating, index, errors) => {
        return new Promise((resolve) => {
            var toProcessMember = updatedMembers[index];

            if(index > updatedMembers.length - 1)
            {
                resolve([updatedMembers, errors]);
            }

            if(toProcessMember.UserID == props.currentUser.UserID)
            {
                return internalBatchRating(updatedMembers, rating, index + 1, errors).then((response) => {
                    resolve(response);
                });
            }

            if(toProcessMember.RatingID)
            {
                internalBatchRating(updatedMembers, rating, index + 1, errors).then((response) => {
                    resolve(response);
                });
            }
            else
            {
                api('/UserRating', 'post', {
                    UserID      : toProcessMember.UserID
                    ,SourceID   : props.sourceId
                    ,SourceType : props.sourceType
                    ,Rating     : rating
                }, 'Bearer ' + props.token)
                    .then((response) => { 

                        internalBatchRating(
                            update(updatedMembers, {
                                $splice : [[
                                    index, 1, response.member
                                ]]
                            })
                            , rating, index + 1, errors
                        ).then((response) => {
                            resolve(response);
                        });

                    })
                    .catch((error) => {
                        errors.push(toProcessMember.UserDisplayName +' : '+error);

                        internalBatchRating(updatedMembers, rating, index + 1, errors).then((response) => {
                            resolve(response);
                        });
                    })
            }

        });
    }
    
    const BatchRating = (rating) => {
        let errors              = [];
        
        let SavingLoader        = popinfo('loader', 'Set-up Ratings', 'Please Wait' );

        internalBatchRating(members, rating, 0, errors)
            .then((response) => {
                setMembers(response[0]);

                if(response[1].length)
                {
                    popinfo('error', 'Set-up Ratings', 'Some data failed to process', {}, SavingLoader);
                }
                else
                {
                    SavingLoader.close();
                }
            })         
    }

    const GiveRating = (member, rating) => {
        let SavingLoader = popinfo('loader', 'Send Rating', 'Your rating helps others to do better' );
        let previousRatingID = member.RatingID;

        api('/UserRating', 'post', {
            UserID      : member.UserID
            ,SourceID   : props.sourceId
            ,SourceType : props.sourceType
            ,Rating     : rating
            ,RatingID   : member.RatingID
        }, 'Bearer ' + props.token)
                .then((response) => {
                    SavingLoader.close();

                    setMembers(update(members, {
                        $splice : [[
                            _.findIndex(members, {UserID : member.UserID})
                            ,1
                            ,update(response.member, {
                                ShowForm : {
                                    $set : !previousRatingID ? window.Date.now() : false
                                }
                            })
                        ]]
                    }));

                })
                .catch((error) => {
                    popinfo('error', 'Saving Rating', error, {}, SavingLoader);
                })

    }

    const isStarActive = (rating, star) => {
        return rating > 0 && star <= rating;
    }
    
    useEffect(() => {

        setMembers(false);

        let endpoint, baseParams;

        switch(props.sourceType)
        {
            case 'as-contributor':
                endpoint = '/UserRating/ByRole';
                baseParams = {
                    role_id : props.sourceId
                }
                break;
            case 'as-admin':
                endpoint = '/UserRating/Admins';
                baseParams = {
                    initiative_id : props.sourceId
                }
                break;
            default:
                break;
        }
        
        var toFetch = [
            api(endpoint, 'get', _.assignIn({}, baseParams, {
                posts_per_page  : props.postsPerPage
                ,paged          : paged
            }) , 'Bearer ' + props.token)
        ]

        if(paged == 1)
        {
            toFetch.push(
                api(endpoint, 'get', _.assignIn({}, baseParams, {
                    posts_per_page  : props.postsPerPage
                    ,get_total      : 1
                }) , 'Bearer ' + props.token)
            );
        }

        Promise.all(toFetch)
            .then((response) => {
                setMembers(_.map(response[0].members, (member) => {
                    member.ShowForm = false;

                    return member;
                }));

                if(paged == 1)
                {
                    setTotal(parseInt(response[1].members) );
                }
            })
            .catch((error) => {
                setMembers([]);
            })

    }, [paged]);

    return(
        <>
        <div className="component-rate-list">
            {
                members !== false && members.length > 0 && props.currentUser &&
                <div className="batch-ratings">
                    <div className="text-xs bold text-right">
                        Update All
                    </div>
                    <div>
                        <StarsList onClick={BatchRating}/>
                    </div>
                </div>
            }
            <ul className="rate-lists">
                {
                    members === false ? <span className="skeleton"></span>  : 
                    members.map((member) => (
                        
                        <li className="the-user" key={member.UserID}>
                            <div className="the-user-wrapper">
                                <AvatarHorizontal2 user={member}/>
                                {
                                    member.UserID != props.currentUser.UserID &&
                                    <>
                                        <StarsList score={member.Rating} onClick={star => {
                                            GiveRating(member, star);
                                        }}/>
                                        <div className="rating-message text-right" >
                                            <RatingMessage 
                                                sourceType={props.sourceType} 
                                                member={member} 
                                                token={props.token} 
                                                show={member.ShowForm} 
                                                onSave={(member) => {
                                                    setMembers(update(members, {
                                                        $splice : [[
                                                            _.findIndex(members, {UserID : member.UserID})
                                                            ,1
                                                            ,member
                                                        ]]
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </>
                                }
                            </div>
                            
                        </li>
                    ))
                }
            </ul>
            {
                total !== false && 
                <PaginationWrapper
                    className="mt-4"
                    activePage={paged}
                    itemsCountPerPage={parseInt(props.postsPerPage)}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={(pagenumber) => {
                        setPaged(pagenumber);
                    }}
                />
            }
        </div>
        </>
    )
}

const RatingInitiativeCardList = connect(stateMap)((props) => {
    const [initatives, setInitiatives]      = useState(false);
    const [total, setTotal]                 = useState(false);
    const [listArgs, setListArgs]           = useState(props.listArgs);

    const [paginationParams]     = useState({
        paged : 1
        ,posts_per_page : 1
    });


    useEffect(() => {
        
        setListArgs(props.listArgs);

    },[props.listArgs.refresh]);

    useEffect(() => {

        setInitiatives(false);

        var args = _.assignIn({}, paginationParams, listArgs );

        var toFetch = [
            api('/UserInitiativeRating', 'get', args, 'Bearer ' + props.auth.token)
        ]

        if(args.paged == 1)
        {
            toFetch.push(
                api('/UserInitiativeRating', 'get', _.assignIn({}, args, {
                    get_total      : 1
                }), 'Bearer ' + props.auth.token)
            );
        }

        Promise.all(toFetch)
            .then((response) => {
                setInitiatives(_.map(response[0].initiative, (rating) => {
                    return rating;
                }));

                if(args.paged == 1)
                {
                    setTotal(parseInt(response[1].initiative) );
                }
            })
            .catch((error) => {
                setInitiatives([]);
            })

    }, [listArgs]);

    return (
        <div className="component-user-rating-card">
            <ul className="user-ratings">
                {
                    initatives !== false && initatives.map((initative) => {

                        return (
                            <li className={`user-rating`} key={initative.InitiativeID}>
                                <div className="user-rating-wrapper">
                                    <div className="user-rating-user">
                                        <div className="mb-md flex flex-wrap v-center">
                                            <div>
                                                <span className="image-box square circle">
                                                    <div aria-label={initative.Rating} role="rating" className="initials-avatar">
                                                        <div>{initative.Rating}</div>
                                                    </div>
                                                </span>
                                            </div>
                                            <div style={{paddingLeft : '24px'}}>
                                                <span className="block bold mt-sm">{initative.InitiativeTitle}</span>
                                            </div>
                                        </div>
                                        <StarsList score={initative.Rating} />
                                    </div>
                                </div>
                            </li>
                        )
                    } )
                }
                {
                    initatives === false && <span className="skeleton"></span>
                }
            </ul>
            {
                total !== false && 
                <PaginationWrapper
                    className="mt-4"
                    activePage={listArgs.paged}
                    itemsCountPerPage={parseInt(listArgs.posts_per_page)}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={(pagenumber) => {
                        setListArgs(update(listArgs, {
                            paged : {
                                $set : pagenumber
                            }
                        }));
                    }}
                />
            }
        </div>
    )
})

const RatingCardList = connect(stateMap)((props) => {
    const [ratings, setRatings]     = useState(false);
    const [total, setTotal]         = useState(false);
    const [listArgs, setListArgs]   = useState(props.listArgs);

    const [paginationParams]     = useState({
        paged : 1
        ,posts_per_page : 1
    });


    useEffect(() => {
        
        setListArgs(props.listArgs);

    },[props.listArgs.refresh]);

    useEffect(() => {

        setRatings(false);

        var args = _.assignIn({}, paginationParams, listArgs );

        var toFetch = [
            api('/UserRating', 'get', args, 'Bearer ' + props.auth.token)
        ]

        if(args.paged == 1)
        {
            toFetch.push(
                api('/UserRating', 'get', _.assignIn({}, args, {
                    get_total      : 1
                }), 'Bearer ' + props.auth.token)
            );
        }

        Promise.all(toFetch)
            .then((response) => {
                setRatings(_.map(response[0].rating, (rating) => {
                    return rating;
                }));

                if(args.paged == 1)
                {
                    setTotal(parseInt(response[1].rating) );
                }
            })
            .catch((error) => {
                setRatings([]);
            })

    }, [listArgs]);

    return (
        <div className="component-user-rating-card">
            <ul className="user-ratings">
                {
                    ratings !== false && ratings.map((rating) => {
                        let UserToDisplayName = rating[props.userToDisplay + 'UserDisplayName'];

                        return (
                            <li className={`user-rating ${rating.RatingMessage && '-has-message'}`} key={rating.RatingID}>
                                <div className="user-rating-wrapper">
                                    <div className="user-rating-user">
                                        {
                                            props.userToDisplay == 'User_' ?
                                            <>
                                                <AvatarVertical2
                                                    user={AvatarReducer(rating, props.userToDisplay)}
                                                />
                                                <div className="leading-text text-xs rating-relation-info">
                                                    {`${format(parseISO(rating.RateDate), 'dd LLLL Y' )}, worked with ${UserToDisplayName} at initiative : ${rating.InitiativeTitle}`}
                                                </div>
                                                <StarsList score={rating.Rating} />
                                            </> : 
                                            <>
                                                <div>
                                                    <span className="image-box square circle">
                                                        <InitialsAvatar name={rating.Rating.toString()} />
                                                    </span>
                                                    <span className="block bold mt-sm leading-relaxed">{rating.InitiativeTitle}</span>
                                                </div>
                                                <div className="leading-text text-xs rating-relation-info">
                                                    {`${format(parseISO(rating.RateDate), 'dd LLLL Y' )}, worked at initiative : ${rating.InitiativeTitle} as ${rating.SourceType == 'as-contributor' ? 'contributor' : 'co-creator'}`}
                                                    {
                                                        rating.SourceType == 'as-contributor' && <span className=""> on {rating.RoleName}</span>
                                                    }
                                                </div>
                                                <StarsList score={rating.Rating} />
                                            </>
                                        }
                                    </div>
                                    {
                                        rating.RatingMessage && 
                                        <div className="user-rating-testimony">
                                            <div className="leading-text text-sm">
                                                {rating.RatingMessage}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </li>
                        )
                    } )
                }
                {
                    ratings === false && <span className="skeleton"></span>
                }
            </ul>
            {
                total !== false && 
                <PaginationWrapper
                    className="mt-4"
                    activePage={listArgs.paged}
                    itemsCountPerPage={parseInt(listArgs.posts_per_page)}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={(pagenumber) => {
                        setListArgs(update(listArgs, {
                            paged : {
                                $set : pagenumber
                            }
                        }));
                    }}
                />
            }
        </div>
    )
})

export { StarsList, RatingsList, RatingCardList, RatingInitiativeCardList }